// 공통 상수 정의 (캐릭터별 로직은 각 config에 이동됨)

/**
 * Voice Server 52채널의 정본 채널명 (인덱스 순서 = 서버 전송 순서 = 표준 ARKit).
 * vrm_filter 이름 기반 매핑의 소스 — VRM morphTargetDictionary 의 키와 대조한다.
 * (아래 blendShapeIndex 객체에는 오타 키(cheekSpuint*)가 있어 이름 소스로 쓰지 않는다)
 */
export const ARKIT_CHANNEL_NAMES: readonly string[] = [
  'browDownLeft', 'browDownRight', 'browInnerUp',
  'browOuterUpLeft', 'browOuterUpRight',
  'cheekPuff', 'cheekSquintLeft', 'cheekSquintRight',
  'eyeBlinkLeft', 'eyeBlinkRight',
  'eyeLookDownLeft', 'eyeLookDownRight',
  'eyeLookInLeft', 'eyeLookInRight',
  'eyeLookOutLeft', 'eyeLookOutRight',
  'eyeLookUpLeft', 'eyeLookUpRight',
  'eyeSquintLeft', 'eyeSquintRight',
  'eyeWideLeft', 'eyeWideRight',
  'jawForward', 'jawLeft', 'jawOpen', 'jawRight',
  'mouthClose',
  'mouthDimpleLeft', 'mouthDimpleRight',
  'mouthFrownLeft', 'mouthFrownRight',
  'mouthFunnel',
  'mouthLeft',
  'mouthLowerDownLeft', 'mouthLowerDownRight',
  'mouthPressLeft', 'mouthPressRight',
  'mouthPucker',
  'mouthRight',
  'mouthRollLower', 'mouthRollUpper',
  'mouthShrugLower', 'mouthShrugUpper',
  'mouthSmileLeft', 'mouthSmileRight',
  'mouthStretchLeft', 'mouthStretchRight',
  'mouthUpperUpLeft', 'mouthUpperUpRight',
  'noseSneerLeft', 'noseSneerRight',
  'tongueOut',
];

/**
 * v3 립싱크 서버(face-lipsync-v3)의 전체 전송 채널 (ARKit 52 + GG 커스텀 'U',''O'').
 * U/O는 ㅜ/ㅗ 라운딩 모음용 — Taekwondo15(GG15).vrm에 동명 모프가 존재한다.
 * vrm_filter는 이 목록을 이름 기반으로 매칭하므로 모프가 없는 아바타에선 자동 무시.
 */
export const SERVER_CHANNEL_NAMES: readonly string[] = [...ARKIT_CHANNEL_NAMES, 'U', 'O'];

export const blendShapeIndex = {
  // browDownLeft
  browDownLeft: 0,
  //browDownRight
  browDownRight: 1,
  // browInnerUp
  browInnerUp: 2,
  // browOuterUpLeft
  browOuterUpLeft: 3,
  // browOuterUpRight
  browOuterUpRight: 4,
  // cheekPuff
  cheekPuff: 5,
  // cheekSpuintLeft
  cheekSpuintLeft: 6,
  // cheekSpuintRight
  cheekSpuintRight: 7,
  // eyeBlinkLeft
  eyeBlinkLeft: 8,
  // eyeBlinkRight
  eyeBlinkRight: 9,
  // eyeLookDownLeft
  eyeLookDownLeft: 10,
  // eyeLookDownRight
  eyeLookDownRight: 11,
  // eyeLookInLeft
  eyeLookInLeft: 12,
  // eyeLookInRight
  eyeLookInRight: 13,
  // eyeLookOutLeft
  eyeLookOutLeft: 14,
  // eyeLookOutRight
  eyeLookOutRight: 15,
  // eyeLookUpLeft
  eyeLookUpLeft: 16,
  // eyeLookUpRight
  eyeLookUpRight: 17,
  // eyeSquintLeft
  eyeSquintLeft: 18,
  // eyeSquintRight
  eyeSquintRight: 19,
  // eyeWideLeft
  eyeWideLeft: 20,
  // eyeWideRight
  eyeWideRight: 21,
  // jawForward
  jawForward: 22,
  // jawLeft
  jawLeft: 23,
  // jawOpen
  jawOpen: 24,
  // jawRight
  jawRight: 25,
  // mouthClose
  mouthClose: 26,
  // mouthDimpleLeft
  mouthDimpleLeft: 27,
  // mouthDimpleRight
  mouthDimpleRight: 28,
  // mouthFrownLeft
  mouthFrownLeft: 29,
  // mouthFrownRight
  mouthFrownRight: 30,
  // mouthFunnel
  mouthFunnel: 31,
  // mouthLeft
  mouthLeft: 32,
  // mouthLowerDownLeft
  mouthLowerDownLeft: 33,
  // mouthLowerDownRight
  mouthLowerDownRight: 34,
  // mouthPressLeft
  mouthPressLeft: 35,
  // mouthPressRight
  mouthPressRight: 36,
  // mouthPucker
  mouthPucker: 37,
  // mouthRight
  mouthRight: 38,
  // mouthRollLower
  mouthRollLower: 39,
  // mouthRollUpper
  mouthRollUpper: 40,
  // mouthShrugLower
  mouthShrugLower: 41,
  // mouthShrugUpper
  mouthShrugUpper: 42,
  // mouthSmileLeft
  mouthSmileLeft: 43,
  // mouthSmileRight
  mouthSmileRight: 44,
  // mouthStretchLeft
  mouthStretchLeft: 45,
  // mouthStretchRight
  mouthStretchRight: 46,
  // mouthUpperUpLeft
  mouthUpperUpLeft: 47,
  // mouthUpperUpRight
  mouthUpperUpRight: 48,
  // noseSneerLeft
  noseSneerLeft: 49,
  // noseSneerRight
  noseSneerRight: 50,
  // tongueOut
  tongueOut: 51,
};

// VRM 모델 전용 BlendShape 인덱스 매핑 (실제 VRM 모델의 인덱스)
export const vrmBlendShapeIndex = {
  // browInnerUp
  browInnerUp: 0,
  // browDownLeft
  browDownLeft: 1,
  // browDownRight
  browDownRight: 2,
  // browOuterUpLeft
  browOuterUpLeft: 3,
  // browOuterUpRight
  browOuterUpRight: 4,
  // eyeLookUpLeft
  eyeLookUpLeft: 5,
  // eyeLookUpRight
  eyeLookUpRight: 6,
  // eyeLookDownLeft
  eyeLookDownLeft: 7,
  // eyeLookDownRight
  eyeLookDownRight: 8,
  // eyeLookInLeft
  eyeLookInLeft: 9,
  // eyeLookInRight
  eyeLookInRight: 10,
  // eyeLookOutLeft
  eyeLookOutLeft: 11,
  // eyeLookOutRight
  eyeLookOutRight: 12,
  // eyeWideLeft
  eyeWideLeft: 17,
  // eyeWideRight
  eyeWideRight: 18,
  // cheekPuff
  cheekPuff: 19,
  // cheekSquintLeft
  cheekSquintLeft: 20,
  // cheekSquintRight
  cheekSquintRight: 21,
  // noseSneerLeft
  noseSneerLeft: 22,
  // noseSneerRight
  noseSneerRight: 23,
  // jawOpen
  jawOpen: 24,
  // jawForward
  jawForward: 25,
  // jawLeft
  jawLeft: 26,
  // jawRight
  jawRight: 27,
  // mouthFunnel
  mouthFunnel: 28,
  // mouthPucker
  mouthPucker: 29,
  // mouthLeft
  mouthLeft: 30,
  // mouthRight
  mouthRight: 31,
  // mouthRollUpper
  mouthRollUpper: 32,
  // mouthRollLower
  mouthRollLower: 33,
  // mouthShrugUpper
  mouthShrugUpper: 34,
  // mouthShrugLower
  mouthShrugLower: 35,
  // mouthClose
  mouthClose: 36,
  // mouthSmileLeft
  mouthSmileLeft: 37,
  // mouthSmileRight
  mouthSmileRight: 38,
  // mouthFrownLeft
  mouthFrownLeft: 39,
  // mouthFrownRight
  mouthFrownRight: 40,
  // mouthDimpleLeft
  mouthDimpleLeft: 41,
  // mouthDimpleRight
  mouthDimpleRight: 42,
  // mouthUpperUpLeft
  mouthUpperUpLeft: 43,
  // mouthUpperUpRight
  mouthUpperUpRight: 44,
  // mouthLowerDownLeft
  mouthLowerDownLeft: 45,
  // mouthLowerDownRight
  mouthLowerDownRight: 46,
  // mouthPressLeft
  mouthPressLeft: 47,
  // mouthPressRight
  mouthPressRight: 48,
  // mouthStretchLeft
  mouthStretchLeft: 49,
  // mouthStretchRight
  mouthStretchRight: 50,
  // tongueOut
  tongueOut: 51,
  // eyeBlinkRight
  eyeBlinkRight: 65,
  // eyeBlinkLeft
  eyeBlinkLeft: 66,
  // eyeSquintRight
  eyeSquintRight: 68,
  // eyeSquintLeft
  eyeSquintLeft: 69,
};

// 표준 ARKit BlendShape 개수 (Voice Server 데이터 정규화용)
export const STANDARD_ARKIT_BLENDSHAPE_COUNT = 52;